import { render, staticRenderFns } from "./hue.vue?vue&type=template&id=5bdf7031&"
import script from "./hue.vue?vue&type=script&lang=js&"
export * from "./hue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdf7031')) {
      api.createRecord('5bdf7031', component.options)
    } else {
      api.reload('5bdf7031', component.options)
    }
    module.hot.accept("./hue.vue?vue&type=template&id=5bdf7031&", function () {
      api.rerender('5bdf7031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-picker/hue.vue"
export default component.exports